import { authenticationService } from "../App";

const url = new URL(location.href);
const baseUrl = url.pathname.startsWith("/production-automation") ? "/production-automation/" : "/"

export function resolvePath(path: string | undefined | null) {
    if (path === undefined) {
        return "";
    }

    return `${baseUrl}${path}`;
}

export function setQRCodeData(id: string | number | null | undefined, data: string) {
    const formData = new FormData();

    if (id) {
        formData.set("id", id.toString());
    }

    formData.set("value", data);

    return fetch(`${baseUrl}api/qr/`, {
        method: "POST",
        body: formData
    });
}

// export function clearQRCodeData(id: string | number) {
//     const formData = new FormData();
//     formData.set("id", id.toString());
//     formData.set("value", "");

//     // return fetch(`${baseUrl}api/qr?${params}`, {
//     return fetch(`https://production.internal.egzotech.com/api/qr`, {
//         method: "POST",
//         body: formData
//     });
// }

// export function getQRCodeData(id: string | number) {
//     const params = new URLSearchParams();
//     params.set("id", id.toString());

//     // return fetch(`${baseUrl}api/qr?${params}`);
//     return fetch(`https://production.internal.egzotech.com/api/qr?${params}`);
// }

export function getQRCodeEventUrl(id: string | number | null | undefined) {
    const params = new URLSearchParams();

    if (id) {
        params.set("id", id.toString());
    }

    params.set("event", "");

    return `https://production.internal.egzotech.com/api/qr?${params}`;
}


// export function utilsFetch(url: string) {
//     const formData = new FormData();
//     formData.set("url", url);
//     return fetch(`${baseUrl}api/utils/fetch/`, {
//         method: "POST",
//         body: formData
//     });
// }

export function utilsWsReq(agent: string, command: string, payload?: string, timeout: number = 10) {
    const params = new URLSearchParams();
    params.set("agent", agent);
    params.set("command", command);
    params.set("timeout", timeout.toString());

    if (payload) {
        params.set("payload", payload);
    }

    return fetch(`${baseUrl}api/utils/wsreq/?${params}`);
}

export function utilsEvent(agent: string, command: string) {
    const params = new URLSearchParams();
    params.set("agent", agent);
    params.set("command", command);
    return `${baseUrl}api/utils/event/?${params}`;
}

// export function utilsProxy(scheme: "http" | "https", host: string, path: string) {
//     return `${baseUrl}api/utils/proxy/${scheme}/${host.replace(/\./gm, "-")}/${path}`;
// }

export async function getStellaBIOCalibrationReport(serial: string) {
    return fetch(`https://functions.egzotech.com/fetch_report_by_serial/${serial.toUpperCase()}`);
}
